import React from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { CascadeOption } from '@/components/form/inputs/CascadeSelect';
import CitySearchOptions from '@/components/form/inputs/CitySearchOptions';
import { Option } from '@/context/job-builder';
import { NATION_WIDE } from '@/constants/city';
import { JOB_RANKING_PAGE_ROUTER_PATH } from '@/constants/router-path';

interface CityOption extends Option {
  pinyin?: string;
}

const CityOptions = React.memo(
  (props: { options: CascadeOption[]; city: string; filterId: string }) => {
    const { options, city, filterId } = props;
    const router = useRouter();
    const pathName = usePathname();

    const cityOptions: CascadeOption[] = React.useMemo(() => {
      return [NATION_WIDE, ...options];
    }, []);

    const cityValue = React.useMemo(() => {
      const findValue = city
        ? cityOptions
            ?.map((item) => {
              if ('children' in item) {
                const childValue = item['children']?.find(
                  (cItem) => cItem.name === city || cItem.pinyin === city,
                );
                if (childValue) {
                  return childValue;
                }
              }
            })
            .filter(Boolean)
        : undefined;
      return findValue && findValue?.length > 0 ? findValue[0] : NATION_WIDE;
    }, []);

    if (!cityOptions.length) {
      return null;
    }

    const handleSelectCity = (selectValue: CityOption) => {
      const endPath = pathName?.endsWith('/topsalary/')
        ? '/topsalary/'
        : pathName?.endsWith('/toppost/')
          ? '/toppost/'
          : '/';
      router.push(
        selectValue.id === NATION_WIDE.id
          ? `${JOB_RANKING_PAGE_ROUTER_PATH}${filterId}${endPath}`
          : `${JOB_RANKING_PAGE_ROUTER_PATH}${selectValue.pinyin}_${filterId}${endPath}`,
      );
    };

    return (
      <CitySearchOptions
        value={cityValue}
        className="w-36"
        options={cityOptions}
        onChange={(selectValue) => handleSelectCity(selectValue)}
      />
    );
  },
);

export default CityOptions;
